import type { RealtimeStatus } from "../hooks/useMerchantRealtime";
import type { HeartbeatStatus } from "../hooks/useHeartbeat";

interface Props {
  realtime: RealtimeStatus;
  heartbeat: HeartbeatStatus;
  audioEnabled: boolean;
  merchantName: string | null;
  onLogout: () => void;
}

// Ehrliche Statusanzeige: unterscheidet Realtime-Verbindung vs. Heartbeat.
// Sagt NICHT "Backend offline", wenn nur der Client-Kanal getrennt ist.
export function TerminalStatusBar({ realtime, heartbeat, audioEnabled, merchantName, onLogout }: Props) {
  const rtLabel =
    realtime === "connected" ? "Live verbunden" : realtime === "connecting" ? "Verbindung wird hergestellt" : "Verbindung unterbrochen";
  const hbLabel = heartbeat === "ok" ? "Terminal online" : heartbeat === "failed" ? "Heartbeat fehlgeschlagen" : "Terminal startet";

  return (
    <div className="statusbar" role="status" aria-live="polite">
      <div className="statusbar__left">
        <span className="statusbar__brand">ShoppiPoint Terminal</span>
        {merchantName && <span className="statusbar__merchant">{merchantName}</span>}
      </div>
      <div className="statusbar__badges">
        <span className={`badge badge--${realtime}`}>{dot(realtime === "connected")} {rtLabel}</span>
        <span className={`badge badge--hb-${heartbeat}`}>{dot(heartbeat === "ok")} {hbLabel}</span>
        <span className={`badge ${audioEnabled ? "badge--ok" : "badge--muted"}`}>
          {audioEnabled ? "🔊 Ton aktiv" : "🔇 Ton aus"}
        </span>
        <button className="btn btn--ghost" onClick={onLogout}>Abmelden</button>
      </div>
    </div>
  );
}

function dot(ok: boolean): string {
  return ok ? "●" : "○";
}
